// Slug generator pra URLs amigaveis no catalogo publico.
// Usado em frontend (gerar link) + backend (montar OG tags).
//
// Estrategia: slug e *ornamental* — sempre acompanhado do id numerico no final.
// Ex: "cloro-para-piscina-estabilizado-10-kg-1325". O backend resolve so pelo id final
// (regex /(\d+)$/) entao se a descricao do produto mudar, urls antigas continuam valendo.

const ACENTOS_MAP: Record<string, string> = {
  'á': 'a', 'à': 'a', 'â': 'a', 'ã': 'a', 'ä': 'a',
  'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e',
  'í': 'i', 'ì': 'i', 'î': 'i', 'ï': 'i',
  'ó': 'o', 'ò': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o',
  'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u',
  'ç': 'c', 'ñ': 'n',
};

export function gerarSlug(s: string | null | undefined): string {
  if (!s) return 'produto';
  let r = s.toLowerCase();
  r = r.replace(/[áàâãäéèêëíìîïóòôõöúùûüçñ]/g, (c) => ACENTOS_MAP[c] ?? c);
  r = r.replace(/[^a-z0-9]+/g, '-');     // qualquer nao-alfanum vira hifen
  r = r.replace(/-+/g, '-');             // colapsa multiplos hifens
  r = r.replace(/^-|-$/g, '');           // tira hifen do inicio/fim
  if (!r) return 'produto';
  return r.length > 80 ? r.slice(0, 80).replace(/-+$/, '') : r;
}

// Monta o slug+id pra URL: "cloro-para-piscina-10kg-1325"
export function montarSlugProduto(descricaoComercial: string | null | undefined, id: number): string {
  return `${gerarSlug(descricaoComercial)}-${id}`;
}

// Extrai o id numerico do final de um slug. Aceita tanto "slug-123" quanto "123" puro.
export function extrairIdDoSlug(slug: string | null | undefined): number | null {
  if (!slug) return null;
  const m = /(\d+)$/.exec(slug);
  if (!m) return null;
  const n = Number(m[1]);
  return Number.isFinite(n) && n > 0 ? n : null;
}
